<template>
  <div class="contain main">
    <h1>Choose a Flavor Below</h1>
    <div>
      <p class="description" v-html="kiosk.description"></p>
    </div>
    <div class="options">
      <div v-for="cannabis in options" :key="cannabis.id" class="option">
        <p @click="showOption(cannabis)" class="btn">{{cannabis.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["kiosk", "options"],
  methods: {
    showOption(selected) {
      this.$emit("show-cannabis", selected);
    }
  }
};
</script>

<style lang='scss'>
.main .description {
  margin-top: 60px;
}
.options {
  display: flex;
  flex-wrap: wrap;
  .option {
    margin-right: 20px;
  }
}
</style>